import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ServerConstants} from '../../../model/ServerConstants';
import {NameServer, TopLevelDomain} from '@iana-rzms/bff-sdk';
import {ChangeVO} from '../../../generate/ChangeVO';


@Component({
    selector: 'name-servers',
    templateUrl: './name-servers.component.html',
    styleUrls: ['./name-servers.component.scss'],
    standalone: false
})
export class NameServersComponent implements OnInit {

  @Input()
  domain: TopLevelDomain;

  @Input()
  nsChange: ChangeVO;

  editmode: boolean;

  @Input()
  pendingRequestChangeID: string;

  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomain>();
  @Input()
  viewMode: boolean;
  @Input()
  hasTechnicalPermission: boolean;
  serverConstants = ServerConstants;

  constructor() {
  }

  ngOnInit() {
  }

  edit(val) {
    this.editmode = val;
  }

  cancel(val) {
    this.edit(false);
  }

  nameServerOutPut(nameServers: Array<NameServer>) {
    this.domain.nameServers = nameServers;
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }

}
